import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Http, Headers, RequestOptions } from '@angular/http';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs';
import { BASE_URI, config } from '../../app.config';

@Injectable()
export class LoginService {

  /** specifying Base URL.*/
  public BASE_URL = BASE_URI.URL;

  constructor(private http: HttpClient) { }

  authenticateEmail(data:any){
    return this.http.post(`${this.BASE_URL}/users/verifyEmail`, data);
  }

  authenticateUser(data:any) {
    return this.http.post(`${this.BASE_URL}/users/authenticate`, data);
  };

  LLmLogin(url:string,company_id:any){
    return this.http.post(url,{"client_id":company_id});
  }

  //AB user login directly from Absence Blueprint payload contains {iv, salt, payload}
  autoLoginAbsenceBlueprint(payload:any) {
    return this.http.post(`${this.BASE_URL}/users/ab/userlogin`, payload);
  }

  loginWithAbsenceBlueprint(payload:any) {
    return this.http.post(`${this.BASE_URL}/users/ab/direct/userlogin`, payload);
  }

};
